export default {
  getNow() {
    const hoy = new Date
    return `${hoy.getFullYear()}-${hoy.getMonth()<10?'0':''}${(hoy.getMonth() + 1)}-${hoy.getDate()<10?'0':''}${hoy.getDate()} ${hoy.getHours()<10?'0':''}${hoy.getHours()}:${hoy.getMinutes()<10?'0':''}${hoy.getMinutes()}:${hoy.getSeconds()<10?'0':''}${hoy.getSeconds()}`         
  },
  getNowFile() {
    const hoy = new Date
    return `${hoy.getFullYear()}${hoy.getMonth()<10?'0':''}${(hoy.getMonth() + 1)}${hoy.getDate()<10?'0':''}${hoy.getDate()}${hoy.getHours()<10?'0':''}${hoy.getHours()}${hoy.getMinutes()<10?'0':''}${hoy.getMinutes()}${hoy.getSeconds()<10?'0':''}${hoy.getSeconds()}${hoy.getMilliseconds()}`         
  },
  getNowDate() {
    const hoy = new Date
    return `${hoy.getFullYear()}-${hoy.getMonth()<10?'0':''}${(hoy.getMonth() + 1)}-${hoy.getDate()<10?'0':''}${hoy.getDate()}`         
  },
  SumarDias(dFecha, dias){
    // fecha puede ser hoy = new Date() o cualquier fecha en formato adecuado.
    // dias puede ser positivo suma negativos resta
    const NuevaFecha = new Date( dFecha.setDate(dFecha.getDate() + dias))
    return `${NuevaFecha.getFullYear()}-${NuevaFecha.getMonth()<10?'0':''}${(NuevaFecha.getMonth() + 1)}-${NuevaFecha.getDate()<10?'0':''}${NuevaFecha.getDate()}`
  },
  getDia() {
    const hoy = new Date
    return `${hoy.getFullYear()}-${this.onConvertirFecha(hoy.getMonth() + 1)}-${this.onConvertirFecha(hoy.getDate())}`         
  },
  onConvertirFecha(nNumero){
    return (nNumero<=9) ? '0' + nNumero : nNumero
  },
  getMesDia() {
    const fechaActual = new Date();
    // obtiene el año actual en formato de 4 dígitos (por ejemplo, 2023)
    const anioActual = fechaActual.getFullYear();
    // obtiene el mes actual como un número (entre 0 y 11, donde 0 = enero, 1 = febrero, etc.)
    // y le agrega 1 (ya que los meses en JavaScript van de 0 a 11)
    const mesActual = fechaActual.getMonth() + 1;
    // combina el año y el mes en un formato de cadena 'YYYY-MM' (por ejemplo, '2023-03')
    const sAnioMesActual = `${anioActual}-${mesActual.toString().padStart(2, '0')}`;

    return sAnioMesActual;
  }
}